// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1Sb7l","large":"styles_large__3FmIV"};